import InfiniteScroll from "react-infinite-scroll-component";
import { SearchContainer } from "../components/search-container";
import { Loader } from "../components/loader";
import { useCallback, useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import {
  ROUTES,
  BASE_URL,
  CATEGORY_NAME_MAP,
  ERROR,
  SUCCESS
} from "../assets/constant";
import axios from "axios";
import { useSelector } from "react-redux";
import { convertInMonthNameFormat } from "../utils/helper";
import PropTypes from "prop-types";
import { CustomModal } from "../components/custom-modal";
import Messages from "../components/message";

export const ReportedIssue = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState({
    data: [],
    total: 0
  });
  const [query, setQuery] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [idToDelete, setIdToDelete] = useState(null);
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertType, setAlertType] = useState(ERROR);

  const page = useRef(1);

  const user = useSelector((state) => state.auth);

  const fetchData = useCallback(async () => {
    try {
      setIsLoading(true);
      const response = await axios.post(
        `${BASE_URL}/issue/get`,
        {
          user_id: user.user.id,
          page: page.current,
          searchQuery: query
        },
        {
          headers: {
            Authorization: `Bearer ${user.token}`
          }
        }
      );

      setData((prevData) => ({
        data:
          page.current !== 1
            ? [...prevData.data, ...(response?.data?.data ?? [])]
            : response?.data?.data,
        total: response?.data?.total
      }));
      page.current = page.current + 1;
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  }, [query, user.token, user.user.id]);

  const handleReportedIssueDelete = async () => {
    try {
      await axios.delete(`${BASE_URL}/issue/delete`, {
        data: {
          id: idToDelete
        },
        headers: {
          Authorization: `Bearer ${user.token}`
        }
      });
      setData((prevData) => ({
        data: prevData.data.filter((d) => d.id !== idToDelete),
        total: prevData.total - 1
      }));
      setShowModal(false);
      setShowAlert(true);
      setAlertMessage("Reported Issue Deleted Successfully");
      setAlertType(SUCCESS);
    } catch (error) {
      setAlertType(ERROR);
      setShowAlert(true);
      setAlertMessage("Failed to delete the Reported Issue");
    } finally {
      window.scrollTo(0, 0);
    }
  };

  const handleConfirmDelete = (id) => {
    setShowModal(true);
    setIdToDelete(id);
  };

  const handleSearch = (value) => {
    setQuery(value);
    setData({ data: [], total: 0 });
    page.current = 1;
  };

  ReportedIssueCard.propTypes = {
    item: PropTypes.shape({
      cat_id: PropTypes.number,
      recall_Id: PropTypes.number,
      id: PropTypes.number,
      subject: PropTypes.string,
      created_at: PropTypes.string,
      description: PropTypes.string
    }).isRequired,
    handleReportedIssueDelete: PropTypes.func.isRequired
  };

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return (
    <div className="subscriber-container">
      <SearchContainer title={"Reported Issue"} handleSearch={handleSearch} />
      <div className="favourite-recalls">
        <h4 style={{ padding: "0 10px" }}>Reported Recalls</h4>
        {showModal && (
          <CustomModal
            isOpen={showModal}
            closeModal={() => setShowModal(false)}
            onClick={handleReportedIssueDelete}
            heading="Delete Reported Issue"
            btnName={"Delete"}
            text="Are you sure you want to delete this reported issue?"
          />
        )}
        {showAlert && (
          <Messages
            message={alertMessage}
            type={alertType}
            onClose={() => setShowAlert(false)}
          />
        )}
        <InfiniteScroll
          dataLength={data.total}
          next={fetchData}
          hasMore={data.data.length < data.total}
          loader={<Loader />}>
          <div className="favourite-recall-list">
            {data?.data?.map((d) => (
              <ReportedIssueCard
                key={d?.id}
                item={d}
                handleReportedIssueDelete={handleConfirmDelete}
              />
            ))}
          </div>

          {data?.data?.length === 0 && !isLoading && (
            <div className="text-center mt-5">
              <h5>No Data Found</h5>
            </div>
          )}

          {data?.data?.length === 0 && isLoading && (
            <div className="text-center mt-5">
              <Loader />
            </div>
          )}
        </InfiniteScroll>
      </div>
    </div>
  );
};

const ReportedIssueCard = ({ item, handleReportedIssueDelete }) => {
  const path = ROUTES.REPORTED_ISSUE_DETAILS.replace(
    ":type/:recallId/:id",
    `${CATEGORY_NAME_MAP[item?.cat_id]}/${item?.recall_Id}/${item?.id}`
  );
  return (
    <div className="recalllistcard" style={{ cursor: "pointer" }}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between"
        }}>
        <Link
          to={`${path}`}
          style={{
            textDecoration: "none",
            color: "black",
            flex: 1
          }}>
          <span style={{ fontWeight: "600", fontSize: "14px" }}>
            {item?.subject}
          </span>
        </Link>
        <button
          style={{
            display: "flex",
            justifyContent: "flex-end",
            flex: "0 0 30px",
            fontSize: "14px",
            background: "none",
            border: "none",
            cursor: "pointer"
          }}
          onClick={(e) => {
            e.stopPropagation();
            handleReportedIssueDelete(item?.id);
          }}
          aria-label="Delete">
          <i className="fa fa-trash" style={{ color: "red" }}></i>
        </button>
      </div>
      <Link
        to={`${path}`}
        style={{
          textDecoration: "none",
          color: "black"
        }}>
        <div
          style={{
            display: "flex",
            marginTop: "10px",
            fontSize: "14px",
            justifyContent: "space-between"
          }}>
          <span style={{fontSize: "14px"}}>
            <span
              style={{
                color: "#DA0063",
                paddingRight: "10px"
              }}>{`Issue Reported:`}</span>
            <span>{item?.description}</span>
          </span>
          <span
            style={{
              display: "flex",
              justifyContent: "flex-end",
              flex: "0 0 auto",
              fontSize: "12px"
            }}>
            {convertInMonthNameFormat(item?.created_at)}
          </span>
        </div>
      </Link>
    </div>
  );
};
